import { createContext, JSX } from 'react'

type State = {
  closePopup: () => void
  setPopup: (popup: JSX.Element) => void
}

export const PopupContext = createContext<State>({
  closePopup: () => {},
  setPopup: () => {},
})
